export default function printReport(name, id, confirmationField = '', idRegister) {
  const token = localStorage.getItem("token");

  const reports = {
    reportVendaOrcamento: () => reportVendaOrcamento(id, token, confirmationField),
    reportSimplesDuasVias: () => reportSimplesDuasVias(id, token, confirmationField),
    reportCoupon: () => reportCoupon(id, token),
    proofOfAcquittance: () => reportProofOfAcquittance(id, token, idRegister),
    thermalreceipt: () => reportThermalReceipt(id, token, idRegister),
    thermalSale: () => thermalSale(id, token),
    acquittance: () => printAcquittance(id, token),
    reportOrder: () => reportOrder(id, token),
    reportCoupon58mm: () => reportCoupon(id, token, true),
    reportContrato: () => reportContrato(id, token),
    contractEditable: () => printContractEditable(id, token),
  }

  if (!reports[name]) {
    console.log('invalid name')
    return
  }

  reports[name]()
}

function reportVendaOrcamento(id, token, confirmationField = '') {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/${id}?auth=${token}&confirmationField=${confirmationField ? true : ''}`
  );
}
function reportSimplesDuasVias(id, token, confirmationField = '') {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/duasVias/${id}?auth=${token}&confirmationField=${confirmationField ? true : ''}`
  );
}
function reportOrder(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nfse/gerar/relatorio/${id}?auth=${token}`
  );
}
function reportCoupon(id, token, is58mm = false) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/coupon/venda/${id}?auth=${token}&is58mm=${is58mm}`
  );
}
function reportProofOfAcquittance(id, token, idRegister) {
  const registerQuery = idRegister
    ? `&idRegister=${encodeURIComponent(idRegister)}`
    : "";

  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/bills/generate/print/proof/of/acquittance/A4/${id}?auth=${token}${registerQuery}`
  );
}
function reportThermalReceipt(id, token, idRegister) {
  const registerQuery = idRegister
    ? `&idRegister=${encodeURIComponent(idRegister)}`
    : "";

  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/bills/generate/print/thermal/${id}?auth=${token}${registerQuery}`
  );
}
function thermalSale(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/thermal/${id}?auth=${token}`
  );
}
function printAcquittance(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/safe/look/for/print/transaction/receipt/cashier/${id}?auth=${token}`
  );
}

function reportContrato(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/contrato/venda/and/desktop/${id}?auth=${token}`
  );
}

async function printContractEditable(id, token ) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/print/contract/editable/${id}?auth=${token}`
  );
}
